"use client"
import logger from "@/lib/logger/logger-init"
import { ResultFactory } from "@/types/generic/Result"

type IncreaseSelectionQuantityResult = {
    success: boolean
    data?: any
    error?: Error
}

export const increaseItemQuantity = async (formData: FormData) => {
    try {
        const response = await fetch("/api/centra/increase-quantity", {
            method: "POST",
            credentials: "include",
            body: formData
        })

        const result = await response.json()

        if (!response.ok || !result.success) {
            const errorMessage = result.error || "Failed to increase quantity"
            logger.warn(errorMessage)
            return ResultFactory.failure<IncreaseSelectionQuantityResult>(
                new Error(errorMessage)
            )
        }

        return ResultFactory.success<IncreaseSelectionQuantityResult>({
            success: true,
            data: result.data
        })
    } catch (error) {
        logger.error("Unexpected error in increaseItemQuantity", error)
        return ResultFactory.failure<IncreaseSelectionQuantityResult>(
            error instanceof Error ? error : new Error("An unknown error occurred")
        )
    }
}
